import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/lasouris.webp';
import screenshot_target from '../../../images/letterfunnel/armandomuis.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Armando Muis"
      firstname="Armando"
      companyname="La Souris"
      competition="Voordeelscooters en AGM"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/armandomuis.js